"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _createUpdateEffect = require("../createUpdateEffect");
var _default = (0, _createUpdateEffect.createUpdateEffect)(_react.useEffect);
exports["default"] = _default;